<p>help-postgresql-checklist works!</p>
